import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {Sidebar} from "primeng/sidebar";

@Component({
  selector: 'app-bottom-sidebar',
  templateUrl: './bottom-sidebar.component.html',
  styleUrls: ['./bottom-sidebar.component.scss'],
  // PrimeNG moves the projected content to body when opening the overlay.
  // Recreate this component on the client so SSR does not lose its form/menu.
  host: {ngSkipHydration: 'true'},
  encapsulation: ViewEncapsulation.None
})
export class BottomSidebarComponent implements OnInit {

  @Input() public isSidebarOpened: boolean = false;
  @Input() public isBackButtonVisible: boolean = false;
  @Output() public onHide: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onGoBack: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(Sidebar) private sidebar: Sidebar;

  constructor() { }

  ngOnInit(): void {
  }

  public hideSidebar(event): void {
    this.sidebar.close(event);
    this.onHide.emit();
  }

  /**
   * Closes the PrimeNG sidebar and resolves only after its body-level mask has
   * left the document. Consumers can safely present an Ionic overlay then.
   */
  public closeAfterMaskDismissed(): Promise<void> {
    if (!this.sidebar || !this.isSidebarOpened) {
      return Promise.resolve();
    }

    const mask = this.sidebar.mask as HTMLElement | null;
    if (!mask) {
      this.sidebar.close(new Event('close'));
      return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
      let settled = false;
      let fallbackTimer: ReturnType<typeof setTimeout> | null = null;
      const finish = () => {
        if (settled) {
          return;
        }
        settled = true;
        if (fallbackTimer !== null) {
          clearTimeout(fallbackTimer);
        }
        mask?.removeEventListener('animationend', finish);
        resolve();
      };

      // PrimeNG's default mask animation lasts 150ms. The fallback protects
      // the creation flow when the platform suppresses animation events.
      fallbackTimer = setTimeout(finish, 250);
      mask.addEventListener('animationend', finish, {once: true});
      this.sidebar.close(new Event('close'));
    });
  }

  goBack(): void {
    this.onGoBack.emit();
  }
}
